import { render, staticRenderFns } from "./releaseDevice.vue?vue&type=template&id=a2634d88&scoped=true"
import script from "./releaseDevice.vue?vue&type=script&lang=js"
export * from "./releaseDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2634d88",
  null
  
)

export default component.exports